import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

const useStyles = makeStyles({
  content: {
    flexGrow: 1,
  },
  categoryTitle: {
    fontWeight: 400,
  },
  total: {
    fontWeight: 500,
  },
  period: {
    color: grey[500],
  },
});

export default useStyles;
